export const formattedPhoneValue = (value: string) => {
    const maxLength = 11;
    const minLength = 0;
    let valuePure = (value.match(/(\d)/g) || []).join('').slice(minLength, maxLength);

    if (valuePure.charAt(minLength) === '8') {
        valuePure = `7${[...valuePure].slice(1).join('')}`;
    } else if (valuePure.charAt(minLength) !== '7' && valuePure.length !== maxLength) {
        valuePure = '7' + valuePure;
    }

    return valuePure;
};